import { Center, Group, Title, Avatar, Menu, rem, Text } from "@mantine/core";
import LogoutIcon from '@mui/icons-material/Logout';
import { Card, message } from "antd";
import Footer from "../Components/Footer/Footer";
import { useEffect, useState } from "react";
import { Adminauthcontexthooks } from "../Hooks/Adminauthcontexthooks";





const Adminhome = () => {

    const [data, setdata] = useState([]);
    const [loading, setloading] = useState(true);
    const { user, adispatch } = Adminauthcontexthooks();
    const [Admindetails, setadmindetails] = useState([]);
    const Logout = () => {
        message.loading("Please wait, Removing Credentials...", 2);
        setTimeout(() => {
            // Remove the token in Session Storage
            sessionStorage.removeItem('user');
            // localStorage.removeItem('expiryTime');
            adispatch({ type: 'LOGOUT' });
            message.success("Successfully Logout");
            setTimeout(() => {
                window.location.href = '/'
            }, 1000);
        }, 2000);
    }
    useEffect(() => {
        if (user) {
            const Get_Admin_Details = async () => {
                const res = await fetch('https://cdr-backend.onrender.com/get/admin-details', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user}`
                    }
                });
                if (res.status === 200) {
                    const data = await res.json();
                    setadmindetails(data.Admindetails);
                    return
                }
            }
            const Get_All_Users = async () => {
                const res = await fetch('https://cdr-backend.onrender.com/get/all-users', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user}`
                    }
                });
                if (res.status === 200) {
                    const data = await res.json();
                    setdata(data.Allusers);
                    setloading(false);
                    return
                }
            }

            Get_All_Users();
            Get_Admin_Details();
        }

    }, [loading, user])
    return (
        <>
            <Center mt={'xs'}><Title c={'dimmed'}>Home</Title></Center>
            <Group justify="flex-end">
                <Title size={'md'} c={'dimmed'}>Welcome,</Title>
                <Menu shadow="md" width={'auto'}>
                    <Menu.Target>
                        <Avatar name={Admindetails.adminemail} color="initials" />
                    </Menu.Target>

                    <Menu.Dropdown>
                        <Menu.Label>Personal Details</Menu.Label>
                        <Menu.Item>
                            <Text size="xs">Name.: {Admindetails.adminemail}</Text>
                            <Text size="xs">Created at.: {Admindetails.createdAt}</Text>
                            <Text size="xs">Account type.: {Admindetails.acc_type}</Text>
                        </Menu.Item>

                        <Menu.Divider />

                        <Menu.Label>Danger zone</Menu.Label>
                        {/* <Menu.Item
                            leftSection={<IconArrowsLeftRight size={14} />}
                        >
                            Transfer my data
                        </Menu.Item> */}
                        <Menu.Item
                            color="red"
                            leftSection={<LogoutIcon style={{ width: rem(14), height: rem(14) }} />}
                            onClick={Logout}
                        >
                            Logout
                        </Menu.Item>
                    </Menu.Dropdown>
                </Menu>
            </Group>
            <Group mt={'md'}>
                <Card title="Total users" size="small" style={{ width: '250px', height: 'auto' }}>
                    <Text>Count:- {data.length}</Text>
                </Card>
                <Card title="Have you facing any problem?" size="small" style={{ width: '500px', height: 'auto' }}>
                    <Title size={'sm'}>Contact us:</Title>
                    <Text>Call us:- 977-387-0841, 770-183-6668</Text>
                    <Text>Mail us:- query.gvinfotech@gmail.com</Text>
                </Card>
            </Group>

            <Footer />

        </>
    )
}
export default Adminhome;